import { render, staticRenderFns } from "./SubscriptionBoxOrderDetail.vue?vue&type=template&id=7648e65a&"
import script from "./SubscriptionBoxOrderDetail.vue?vue&type=script&lang=js&"
export * from "./SubscriptionBoxOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionBoxOrderDetail.vue?vue&type=style&index=0&id=7648e65a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports